import { endOfDay } from 'date-fns';
import { Box } from 'src/components/Box';
import { DateRangePicker } from 'src/components/DateRangePicker';
import { formatMonthDayYear } from 'src/utils/dateFormatter';

interface DateRangeFilterValue {
  start: string;
  end: string;
}
interface DateRangeFilterProps {
  field: string;
  label: string;
  value: any;
  setValue: (newVal: DateRangeFilterValue) => void;
  valueOnly?: boolean;
  showShortcuts?: boolean;
  minDate?: Date;
  maxDate?: Date;
}
export const DateRangeFilter = ({
  label,
  setValue,
  value,
  valueOnly,
  showShortcuts = true,
  minDate,
  maxDate,
}: DateRangeFilterProps) => {
  if (valueOnly) {
    return (
      <>
        {formatMonthDayYear(value?.start)} - {formatMonthDayYear(value?.end)}
      </>
    );
  }
  return (
    <Box>
      <DateRangePicker
        label={label}
        multiInput
        showShortcuts={showShortcuts}
        minDate={minDate}
        maxDate={maxDate}
        value={[
          value?.start ? new Date(value?.start) : null,
          value?.end ? new Date(value?.end) : null,
        ]}
        onChange={(newValue) => {
          if (newValue[0] && newValue[1]) {
            setValue({
              ...value,
              start: newValue[0]?.toISOString(),
              end: newValue[1] ? endOfDay(newValue[1]).toISOString() : null,
            });
          }
        }}
      />
    </Box>
  );
};
